import React, { useState } from 'react';
import Footer from '../components/Footer';

const TermsAndConditions = () => {
  const [activeSection, setActiveSection] = useState(null);

  const toggleSection = (sectionId) => {
    setActiveSection(activeSection === sectionId ? null : sectionId);
  };

  const terms = [
    {
      id: 'overview',
      title: 'Overview',
      content: `These Terms and Conditions ("Terms") govern your use of the Weedhurry platform and services (collectively, the "Services") operated by Weedhurry ("we," "us," or "our"). By accessing or using our Services, including simply browsing our website, you agree to be bound by these Terms. If you disagree with any part of these Terms, you must immediately discontinue your access to and use of the Services.`
    },
    {
      id: 'definitions',
      title: 'Definitions',
      content: `"Marketplace" refers to the Weedhurry platform where Vendors and Customers connect.
"Vendor" refers to any business that offers products for sale through the Marketplace.
"Customer" refers to any individual who purchases products from Vendors through the Marketplace.
"Content" refers to all information, data, and materials uploaded to or displayed on the Marketplace.`
    },
    {
      id: 'account',
      title: 'Account Registration',
      content: `To use certain features of the Services, you must register for an account. You agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete. You are responsible for safeguarding your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.`
    },
    {
      id: 'marketplace',
      title: 'Marketplace Operations',
      content: `Weedhurry provides a platform connecting Vendors and Customers but is not a party to any transaction between them. We do not control, guarantee, or assume responsibility for Vendors' products or services. Vendors are solely responsible for their Content, products, and services.

We reserve the right to remove any Content that violates these Terms or that we determine, in our sole discretion, is otherwise objectionable.`
    },
    {
      id: 'vendor',
      title: 'Vendor Obligations',
      content: `Vendors must:
- Comply with all applicable laws and regulations
- Provide accurate and complete information about their products
- Fulfill orders as advertised and in a timely manner
- Maintain accurate inventory and pricing information
- Handle customer service issues related to their products
- Obtain all necessary licenses, permits, and authorizations to operate their business and sell their products
- Pay all applicable taxes related to their sales

Vendors acknowledge that Weedhurry may suspend or terminate their access to the Services for violations of these Terms.`
    },
    {
      id: 'customer',
      title: 'Customer Obligations',
      content: `Customers must:
- Provide accurate and complete information when creating an account and placing orders
- Be of legal age to purchase the products offered
- Pay for orders as agreed
- Comply with all applicable laws and regulations

Customers acknowledge that Weedhurry is not responsible for the quality, safety, legality, or delivery of products purchased from Vendors.`
    },
    {
      id: 'prohibited',
      title: 'Prohibited Activities',
      content: `You agree not to:
- Use the Services for any illegal purpose
- Violate any applicable laws or regulations
- Infringe upon the rights of others
- Interfere with or disrupt the Services
- Attempt to gain unauthorized access to the Services
- Use automated means to access or collect data from the Services
- Impersonate any person or entity
- Transmit any harmful code or materials`
    },
    {
      id: 'intellectual',
      title: 'Intellectual Property',
      content: `The Services and all content and materials available through the Services are protected by intellectual property laws. You may not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any content from the Services without our prior written consent or that of the respective owner.

By posting Content to the Services, you grant us a non-exclusive, worldwide, royalty-free license to use, reproduce, modify, adapt, publish, translate, distribute, and display such Content in connection with providing and promoting the Services.`
    },
    {
      id: 'disclaimer',
      title: 'Disclaimer of Warranties',
      content: `THE SERVICES ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.

WE DO NOT WARRANT THAT THE SERVICES WILL BE UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE, THAT DEFECTS WILL BE CORRECTED, OR THAT THE SERVICES OR THE SERVERS THAT MAKE THEM AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.`
    },
    {
      id: 'limitation',
      title: 'Limitation of Liability',
      content: `TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT WILL WEEDHURRY, ITS AFFILIATES, OR THEIR LICENSORS, SERVICE PROVIDERS, EMPLOYEES, AGENTS, OFFICERS, OR DIRECTORS BE LIABLE FOR DAMAGES OF ANY KIND, UNDER ANY LEGAL THEORY, ARISING OUT OF OR IN CONNECTION WITH YOUR USE, OR INABILITY TO USE, THE SERVICES, INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO, PERSONAL INJURY, PAIN AND SUFFERING, EMOTIONAL DISTRESS, LOSS OF REVENUE, LOSS OF PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS, LOSS OF USE, LOSS OF GOODWILL, LOSS OF DATA, AND WHETHER CAUSED BY TORT (INCLUDING NEGLIGENCE), BREACH OF CONTRACT OR OTHERWISE, EVEN IF FORESEEABLE.

THE FOREGOING DOES NOT AFFECT ANY LIABILITY WHICH CANNOT BE EXCLUDED OR LIMITED UNDER APPLICABLE LAW.`
    },
    {
      id: 'indemnification',
      title: 'Indemnification',
      content: `You agree to defend, indemnify, and hold harmless Weedhurry, its affiliates, licensors, and service providers, and its and their respective officers, directors, employees, contractors, agents, licensors, suppliers, successors, and assigns from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising out of or relating to your violation of these Terms or your use of the Services.`
    },
    {
      id: 'changes',
      title: 'Changes to Terms',
      content: `We may revise and update these Terms from time to time in our sole discretion. All changes are effective immediately when we post them. Your continued use of the Services following the posting of revised Terms means that you accept and agree to the changes.`
    },
    {
      id: 'termination',
      title: 'Termination',
      content: `We may terminate or suspend your access to the Services immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms. Upon termination, your right to use the Services will immediately cease.`
    },
    {
      id: 'governing',
      title: 'Governing Law',
      content: `These Terms and any dispute or claim arising out of or in connection with them or their subject matter or formation shall be governed by and construed in accordance with the laws of the state where Weedhurry is headquartered, without giving effect to any choice or conflict of law provision or rule.`
    },
    {
      id: 'disputes',
      title: 'Dispute Resolution',
      content: `Any legal action or proceeding arising out of or relating to these Terms or your use of the Services shall be brought exclusively in the federal or state courts located in the jurisdiction where Weedhurry is headquartered, and you consent to the personal jurisdiction and venue of such courts.`
    },
    {
      id: 'contact',
      title: 'Contact Information',
      content: `If you have any questions about these Terms, please contact us at [YOUR CONTACT EMAIL].`
    }
  ];

  const styles = {
    container: {
      maxWidth: '960px',
      margin: '0 auto',
      padding: '20px',
      fontFamily: 'Arial, sans-serif'
    },
    header: {
      borderBottom: '1px solid #eee',
      paddingBottom: '20px',
      marginBottom: '20px'
    },
    title: {
      fontSize: '24px',
      fontWeight: 'bold',
      marginBottom: '10px',
      color: '#333'
    },
    lastUpdated: {
      fontSize: '14px',
      color: '#666',
      marginBottom: '20px'
    },
    section: {
      marginBottom: '15px',
      border: '1px solid #ddd',
      borderRadius: '4px'
    },
    sectionHeader: {
      padding: '12px 15px',
      backgroundColor: '#f8f8f8',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontWeight: 'bold',
      borderBottom: '1px solid #ddd'
    },
    sectionContent: {
      padding: '15px',
      lineHeight: '1.5',
      backgroundColor: '#fff',
      whiteSpace: 'pre-line'
    },
    noteContainer: {
      marginTop: '30px',
      paddingTop: '20px',
      borderTop: '1px solid #eee'
    },
    legalNote: {
      padding: '15px',
      backgroundColor: '#f8f8f8',
      border: '1px solid #ddd',
      borderRadius: '4px',
      fontSize: '14px',
      lineHeight: '1.5',
      fontStyle: 'italic',
      color: '#555'
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>Terms and Conditions</h1>
        <p style={styles.lastUpdated}>Last Updated: March 18, 2025</p>
      </div>

      {terms.map((section) => (
        <div key={section.id} style={styles.section}>
          <div 
            style={styles.sectionHeader}
            onClick={() => toggleSection(section.id)}
          >
            {section.title}
            {activeSection === section.id ? '▲' : '▼'}
          </div>
          {activeSection === section.id && (
            <div style={styles.sectionContent}>
              {section.content}
            </div>
          )}
        </div>
      ))}

      <div style={styles.noteContainer}>
        <p style={styles.legalNote}>By accessing or using the Weedhurry website or services, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use this site.</p>
      </div>
      
      <Footer />
    </div>
  );
};

export default TermsAndConditions;